import React, { useState } from 'react'
import DatePicker from '../../../shared/DatePicker'
import DropdownField from '../../../shared/DropdownField'
import CustomButton from '../../../shared/CustomButton'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { visitStatusOptions } from '../../../utils/dropdownOptions'

const VisitHistoryFilter = ({
  payloadData,
  setPayloadData,
  applyFilters,
  resetFilters,
  patientDetails
}) => {
  const { t } = useTranslation()

  const handleChange = event => {
    const { name, value } = event.target || {}
    setPayloadData(prevValues => ({
      ...prevValues,
      [name]: moment(value).format('YYYY-MM-DD')
    }))
  }

  const handleApplyFilters = () => {
    applyFilters()
  }

  const handleResetFilters = () => {
    resetFilters()
  }
  return (
    <div className='grid grid-cols-12 lg:grid-cols-11 gap-x-3 mb-2'>
      <DatePicker
        name='start_date'
        value={
          payloadData?.start_date
            ? moment(payloadData?.start_date, 'YYYY-MM-DD').toDate()
            : ''
        }
        onChange={handleChange}
        useFormik={false}
        placeholder={t('StartDate')}
        className='col-span-12 md:col-span-4 lg:col-span-2'
      />
      <DatePicker
        name='end_date'
        value={
          payloadData?.end_date
            ? moment(payloadData?.end_date, 'YYYY-MM-DD').toDate()
            : ''
        }
        onChange={handleChange}
        useFormik={false}
        placeholder={t('EndDate')}
        className='col-span-12 md:col-span-4 lg:col-span-2'
      />
      <DropdownField
        name='status'
        value={payloadData?.status}
        useFormik={false}
        placeholder={t('Selectstatus')}
        className='col-span-12 md:col-span-4 lg:col-span-2'
        options={visitStatusOptions}
        onChange={event => {
          let payload = {
            ...payloadData,
            status: event?.target?.value
          }
          setPayloadData(payload)
        }}
      />
      <div className='flex items-center gap-2 mb-3 col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-3'>
        <CustomButton
          label={t('ApplyFilters')}
          buttonType='primary'
          icon={'pi pi-filter'}
          className='w-fit h-[35px]'
          onClick={handleApplyFilters}
        />
        <CustomButton
          label={t('Reset')}
          buttonType='reset'
          icon={'pi pi-sync'}
          className='w-fit h-[35px]'
          onClick={handleResetFilters}
        />
      </div>
    </div>
  )
}

export default VisitHistoryFilter
